import { InjectionToken } from '@angular/core';

/** Whether the confirmation step's email field can be typed into; defaults to `true`. See `libs/flows/onboarding/README.md`. */
export const FLOW_EMAIL_EDITABLE = new InjectionToken<boolean>(
  'FLOW_EMAIL_EDITABLE',
  {
    providedIn: 'root',
    factory: () => true,
  },
);
